import React, {useEffect} from 'react';
import moment from 'moment';
import * as countdown from 'countdown';
import {useTranslation} from 'react-i18next';
require('moment-countdown');

const Countdown = ({remainingMs}) => {
  const {t, i18n} = useTranslation();

  useEffect(() => {
    switch (i18n.language) {
      case 'fr':
        countdown.setLabels(
          ' milliseconde| seconde| minute| heure| jour| semaine| mois| année| décennie| siècle| millénaire',
          ' millisecondes| secondes| minutes| heures| jours| semaines| mois| années| décennies| siècles| millénaires',
          ' et ',
          ', ',
          'maintenant',
        );
        break;
      default:
        countdown.resetLabels();
        break;
    }
  }, [i18n.language]);

  return (
    <div className="multiplex-countdown">
      {t('votre-seance-commence-dans-{countdown}', {countdown: moment().subtract(remainingMs).countdown().toString()})}
    </div>
  );
};

export default Countdown;
